import React, { useCallback, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { DOWNLOAD_KEYS } from 'components/Downloads/constants';
import { IReports } from 'components/Downloads/types';
import { Tab } from 'components/Tabs';
import { appReactMemo } from 'hocs';
import { TabsContainer, TabsSection } from 'routes/pages/AuthorizedStack/styled';

import ReportGrid from './ReportGrid';

const ReportTabs = ({ reports }: { reports: IReports[] }) => {
  const { i18n, t } = useTranslation();

  const [queryTab, setQueryTab] = useState<DOWNLOAD_KEYS>();

  const tabList = useMemo(
    () => reports.map((report, index) => report.key || `tab${index}`),
    [reports],
  );

  const onTabChange = useCallback((_e: React.SyntheticEvent, newValue: string) => {
    setQueryTab(newValue as DOWNLOAD_KEYS);
  }, []);

  const selectedTabPath = useMemo(() => {
    return reports.filter(
      (report, index) => (report.key || `tab${index}`) === (queryTab || tabList[0]),
    )[0].path;
  }, [reports, queryTab, tabList]);

  return (
    <ReportGrid path={selectedTabPath}>
      {({ content, createComponent }) => (
        <>
          <TabsSection $isTransparent>
            <TabsContainer
              onChange={onTabChange}
              useKeyValue
              value={queryTab || tabList[0]}
            >
              {tabList.map((tab, index) => (
                <Tab
                  key={index}
                  label={
                    i18n.exists(`common.reportModal.tabs.${tab}`)
                      ? t(`common.reportModal.tabs.${tab}` as never)
                      : tab
                  }
                  tabKey={tab}
                />
              ))}
            </TabsContainer>
            {createComponent}
          </TabsSection>
          {content}
        </>
      )}
    </ReportGrid>
  );
};

export default appReactMemo(ReportTabs);
